import { Steps } from 'antd';

type CustomStepProps = {
  current: number;
};

const items = [
  {
    title: 'Захиалга үүсгэх',
  },
  {
    title: 'Төлбөр төлөх',
  },
  {
    title: 'Дуусгах',
  },
];

const CustomStep = ({ current }: CustomStepProps) => {
  return (
    <div className="step-container">
      <Steps responsive={false} progressDot current={current || 0} items={items} />
    </div>
  );
};

export default CustomStep;
